// Generated using typescript-generator version null on 2019-11-20 11:42:08.

import {Observable} from 'rxjs/Rx';
import {Injectable} from '@angular/core';
import {HttpResponse} from "@angular/common/http";


export class ResultFixedAnomaliesDto {
  numeroDossier?: string;
  validationResults?: ValidationResultsDto[];
}

export class DossierBloquerRequest {
  numeroDossier? : string;
  codeCorrespondant? :string;
  cleLigneAnalyseResultat? :string;
}

export class ValidationResultsDto {
  anomalyFix?: AnomalyFixDto;
  statusCode?: string;
  returnCode?: string;
  returnMessage?: string;
}

export class AnomalyFixDto {
  typeAnomalie?: string;
  languageCode?: string;
  numeroEtiquettePrelevement?: string;
  cleLigneAnalyseResultat?: string;
  codeAnalyseAAjouter?: string;
  resultatAnalyse?: string;
  codeMedecin?: string;
  typeAnomalieCode?: string;
}

export class CodeDto implements Dto {
  cleLigneAnalyseResultat?: string;
  keyCode?: string;
  langueCorrespondant?: string;
  valueCode?: string;
}

export class DossierBloqueDto implements Dto {
  id?: number;
  cleLigneAnalyseResultat?: string;
  codeAnalyseAAjouter?: string;
  codeCorrespondant?: string;
  langueCorrespondant?: string;
  libelleAnalyseResultat?: string;
  numeroDossier?: string;
  numeroEtiquettePrelevement?: string;
  typeAnomalie?: string;
  typeResultatAttendu?: string;
  seuilAlerteInf?: number;
  seuilAlerteSup?: number;
  resultatAnalyseSaisie?: string;
  resultatAnalyseConfirm?: boolean;
  dateHeureSaisie?: Date;
  codeCorrespondantSaisie?: string;
  etat?: string;
  codeList?: CodeDto[];
  nomFichier?: string;
  lock?: boolean;
  motifRejet?: string;
  lienFichier?: string;
  codeDocumentGED?: string;
  visa?: string;
}

export class FileProperties implements Dto {
  fileExtensions?: string;
  fileMaxSize?: string;
}

export class DocumentInformation implements Dto {
  cleLigneAnalyseResultat?: string;
  codeCorrespondant?: string;
  numeroDossier?: string;
  action?: string;
}

export class TagLightDto implements Dto {
  libelle: string;
  code: string;
}

export abstract class HttpClient {

  abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

export class CategorieFormulaireDto implements Dto {
  id?: number;
  code?: string;
  libelle?: string;
}

export class InstanceModeleFormulaireDto implements Dto {
  id?: number;
  idModeleFormulaire?: number;
  idUser?: number;
  status?: string;
  modifiable?: boolean;
  dateCreation?: string;
}

export class SaveInstanceModeleFormulaireDto {
  instance?: InstanceModeleFormulaireDto;
  valeurs?: ValeursInstanceDto[];
}

export class PaginateRequestDto {
  pageIndex?: number;
  nbElementsParPage?: number;
}

export class PaginateRequestWithTriDto<E> extends PaginateRequestDto {
  tri: E;
  asc?: boolean;
}

export class RechercherDossierBloqueFilterDto extends PaginateRequestWithTriDto<RechercheDossierBloqueTriEnum> implements Dto {
  nomPrenomPatientRefLabo?: string;
  numeroDossier?: string;
  debutDateCreation?: any;
  finDateCreation?: any;
  typeAnomalieEnums?: TypeAnomalieEnum[];
  etatEnums?: EtatEnum[];
  codesCorrespondants?: string[];
}

export class RechercheInstanceModeleFormulaireDto extends PaginateRequestDto implements Dto {
  titre?: string;
  nom?: string;
  nDossier?: string;
  categories?: string[];
  statuts?: StatutDemandeEnum[];
  debutDateCreation?: any;
  finDateCreation?: any;
  numeroDossier?: string;
  correspondantsCode?: string[];
}

export class AutocompleteDto implements Dto {
  libelle: string;
}

export class PaginationResultDto<T> implements Dto {
  limitExceeded?: boolean;
  pagination?: PaginationResult<T>;
}

export class PaginationDossierBloqueResultDto extends PaginationResultDto<DossierBloqueLightDto> {
}

export class DossierBloqueLightDto implements Dto {
  numeroDossier?: string;
  etat?: string;
  nombreAnomalieResultat?: number;
  nombreAnomalieDocument?: number;
  referenceLabo?: string;
  identifiantLabo?: string;
  nomLaboratoire?: string;
  nom?: string;
  nomJeuneFille?: string;
  prenom?: string;
  codeCorrespondant?: string;
  dateCreation?: any;
  dateNaissance?: any;
}

export class PaginationInstanceModeleFormulaireResultDto extends PaginationResultDto<LigneInstanceModeleFormulaireDto> {
}

export class SaveModeleFormulaireDto implements Dto {
  id?: number;
  titre?: string;
  image?: CreateRessourceMultimediaDto;
  tags?: string;
  idCategorieFormulaire?: number;
  urlHtmlFile?: string;
  fileName?: string;
  modifiable?: boolean;
  forUpdate?: boolean;
}

export class ModeleFormulaireDto implements Dto {
  id?: number;
  titre?: string;
  idImage?: number;
  tags?: string;
  idCategorieFormulaire?: number;
  modifiable?: boolean;
  urlHtmlFile?: string;
}

export class RechercheModeleDto extends PaginateRequestWithTriDto<RechercheModeleTriEnum> implements Dto {
  titre?: string;
  categories?: CategorieFormulaireDto[];
}

export class PaginationModeleResultDto extends PaginationResultDto<ModeleFormulaireLightDto> {
}

export class Response implements AutoCloseable {
  mediaType?: MediaType;
  metadata?: any;
  lastModified?: Date;
  date?: Date;
  headers?: any;
  entity?: any;
  status?: number;
  statusInfo?: StatusType;
  allowedMethods?: string[];
  cookies?: { [index: string]: NewCookie };
  entityTag?: EntityTag;
  links?: Link[];
  stringHeaders?: any;
  length?: number;
  language?: Locale;
  location?: URI;
}

export class CorrespondantDetailsDto {
  code?: string;
  nom?: string;
  adressePrincipale?: AdresseDto;
  adresseLivraison?: AdresseDto;
  telephone?: string;
  fax?: string;
  email?: string;
  numFiness?: string;
  numAdeli?: string;
  codeRpps?: string;
  typeCarte?: string;
  correspondantParent?: string;
}

export class UserInformations {
  id?: string;
  login?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  role?: UserRole;
  lang?: Locale;
  origine?: string;
  url?: string;
  date?: any;
  expires?: any;
  metadata?: { [index: string]: any };
  modules?: string[];
  correspondants?: Correspondant[];
  codeRpps?: string;

  properties?: { [index: string]: any };
  'e-mail'?: string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;
}

export class Profil {
  id?: number;
  libelle?: string;
  champs?: string;
}

export interface Dto {
}

export class ValeursInstanceDto implements Dto {
  id?: number;
  idInstanceModele?: number;
  cle?: string;
  valeur?: string;
}

export class PaginationResult<T> {
  pageIndex: number;
  totalPages: number;
  totalElements: number;
  results: T[];
}

export class CreateRessourceMultimediaDto implements Dto {
  name?: string;
  mimeType?: string;
  size?: number;
  content?: string;
}

export class MediaType {
  type?: string;
  subtype?: string;
  parameters?: { [index: string]: string };
  wildcardType?: boolean;
  wildcardSubtype?: boolean;
}

export interface StatusType {
  statusCode?: number;
  reasonPhrase?: string;
  family?: Family;
}

export class Cookie {
  name?: string;
  value?: string;
  version?: number;
  path?: string;
  domain?: string;
}

export class NewCookie extends Cookie {
  comment?: string;
  maxAge?: number;
  expiry?: Date;
  secure?: boolean;
  httpOnly?: boolean;
}

export class EntityTag {
  value?: string;
  weak?: boolean;
}

export class Link {
  rel?: string;
  rels?: string[];
  uriBuilder?: UriBuilder;
  uri?: URI;
  params?: { [index: string]: string };
  title?: string;
  type?: string;
}

export class Locale {
}

export class URI {
}

export interface AutoCloseable {
}

export class GedFileDescription {
  url?: string;
  nom?: string;
  locale?: Locale;
}

export class AdresseDto {
  ligne1?: string;
  ligne2?: string;
  ligne3?: string;
  codePostal?: string;
  ville?: string;
  pays?: string;
}

export class CorrespondantDto implements Dto {
  code?: string;
  nom?: string;
  tags?: string[];
}

export class Correspondant {
  code?: string;
  nom?: string;
  tags?: string[];
  dateDesactivation?: any;
  metadata?: { [index: string]: any };
}

export class LigneInstanceModeleFormulaireDto implements Dto {
  id?: number;
  titreModele?: string;
  categorie?: CategorieFormulaireDto;
  dateCreation?: any;
  statut?: StatutDemandeEnum;
  numeroDossier?: string;
  nomPrenom?: string;
}

export class ModeleFormulaireLightDto implements Dto {
  id?: number;
  titre?: string;
  categorie?: CategorieFormulaireDto;
}

export class UriBuilder {
}

export class LigneDossierDto implements Dto {
  id: number;
  identifiant: string;
  nom: string;
  nomJeuneFille: string;
  prenom: string;
}

@Injectable()
export class IAuditWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /info
   * Response code 200 - Le log a Ã©tÃ© ajoutÃ© avec succÃ¨s
   * Response code 500 - Erreur interne lors du log d'audit
   * HTTP POST /audit/info
   * Java method: fr.cerba.digicerba.authentification.webservices.audit.IAuditWebService.info
   */
  info(queryParams?: { url?: string; message?: string; }): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`audit/info`, queryParams: queryParams});
  }
}

@Injectable()
export class ICategorieFormulaireWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /categorieformulaire/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.ICategorieFormulaireWebService.getCategorieFormulaire
   */
  getCategorieFormulaire(id: number): RestResponse<CategorieFormulaireDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`categorieformulaire/${id}`});
  }

  /**
   * HTTP GET /categorieformulaire/all
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.ICategorieFormulaireWebService.getCategorieFormulaireAll
   */
  getCategorieFormulaireAll(): RestResponse<CategorieFormulaireDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`categorieformulaire/all`});
  }
}

@Injectable()
export class IDocumentWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /document/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IDocumentWebService.getDocument
   */
  getDocument(id: number): RestResponse<any> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`document/${id}`});
  }
}

@Injectable()
export class IDossierBloqueWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * rechercher
   * Response code 200 - Recherche terminÃ©e
   * HTTP POST /dossierbloque/rechercher
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IDossierBloqueWebService.rechercheDossierBloques
   */
  rechercheDossierBloques(arg0: RechercherDossierBloqueFilterDto): RestResponse<PaginationDossierBloqueResultDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`dossierbloque/rechercher`, data: arg0});
  }

  /**
   * Response code 200 - Récuperation des anomalies d'un dossier
   * HTTP GET /dossierbloque/detail/{numerodossier}/etat/{etat}
   * Java method: fr/cerba/digicerba/formulairedemat/webservices/IDossierBloqueWebService.getDetailsByNumeroDossierAndEtat
   */
  getDetailsByNumeroDossierAndEtat(numerodossier: string, etat: EtatEnum): RestResponse<DossierBloqueDto[]> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`dossierbloque/detail/${numerodossier}/etat/${etat}`
    });
  }

  /**
   * fixeranomalie
   * Response code 200 - Listes des anomalies après traitement, renvoie notamment un statut OK ou KO
   * HTTP POST dossierbloque/fixedanomaly
   * Java method: fr/cerba/digicerba/formulairedemat/webservices/IDossierBloqueWebService.appelFixedCerbaAnomalies
   */
  fixerAnomalies(arg0: DossierBloqueDto[]): RestResponse<ResultFixedAnomaliesDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`dossierbloque/fixedanomaly`, data: arg0});
  }

  /**
   * fixeranomalie
   * Response code 200 - Listes des anomalies après traitement, renvoie notamment un statut OK ou KO
   * HTTP POST dossierbloque/fixDocumentAnomalies
   * Java method: fr/cerba/digicerba/formulairedemat/webservices/IDossierBloqueWebService.appelFixedCerbaAnomalies
   */
  fixDocumentAnomalies(dossierBloqueDto: DossierBloqueDto, file: File): RestResponse<ResultFixedAnomaliesDto> {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`dossierbloque/document/fixanomalies/${dossierBloqueDto.numeroDossier}/${dossierBloqueDto.cleLigneAnalyseResultat}/${dossierBloqueDto.codeCorrespondant}/${dossierBloqueDto.nomFichier}`,
      data: formData
    });
  }

  deleteFileDossierBloque(dossierBloqueDto: DossierBloqueDto){
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`dossierbloque/document/delete/${dossierBloqueDto.numeroDossier}/${dossierBloqueDto.cleLigneAnalyseResultat}/${dossierBloqueDto.codeCorrespondant}`
    });
  }

      /**
   * fileproperties
   * Response code 200 - Récuperation des extensions et de la taille d'un fichier pour un document
   * HTTP GET dossierbloque/document/fileproperties
   * Java method: fr/cerba/digicerba/formulairedemat/webservices/IDossierBloqueWebService.fileproperties
   */
  getFileProperties(): RestResponse<FileProperties> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`dossierbloque/document/fileproperties`,
    });
  }

  /**
   * downloadFile
   * Response code 200 - download file
   * HTTP GET dossierbloque/document/download
   * Java method: fr/cerba/digicerba/formulairedemat/webservices/IDossierBloqueWebService.downloadFile
   */

   downloadFile(documentRequest : DossierBloquerRequest ): RestResponse<HttpResponse<Blob>>{
     return this.httpClient.request({
       method: 'POST-BLOB',
       url: uriEncoding`dossierbloque/document/download`,
       data : documentRequest
     });
  }
}

@Injectable()
export class IInstanceModeleFormulaireWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /instancemodele/{id}/access
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.getAuthorizationAccessEdit
   */
  getAuthorizationAccessEdit(id: number): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`instancemodele/${id}/access`});
  }

  /**
   * HTTP GET /instancemodele/guest/url/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.getGuestUrl
   */
  getGuestUrl(id: number): RestResponse<string> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`instancemodele/guest/url/${id}`});
  }

  /**
   * HTTP GET /instancemodele/get/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.getInstanceModele
   */
  getInstanceModele(id: string, arg0: number): RestResponse<InstanceModeleFormulaireDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`instancemodele/get/${id}`, data: arg0});
  }

  /**
   * HTTP GET /instancemodele/get/detail/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.getInstanceModeleComplete
   */
  getInstanceModeleComplete(id: number): RestResponse<SaveInstanceModeleFormulaireDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`instancemodele/get/detail/${id}`});
  }

  /**
   * HTTP PUT /instancemodele/modifier
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.modifierInstanceModeleFormulaire
   */
  modifierInstanceModeleFormulaire(arg0: SaveInstanceModeleFormulaireDto): RestResponse<number> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`instancemodele/modifier`, data: arg0});
  }

  /**
   * HTTP POST /instancemodele/ajouter
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.saveInstanceModeleFormulaire
   */
  saveInstanceModeleFormulaire(arg0: SaveInstanceModeleFormulaireDto): RestResponse<number> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`instancemodele/ajouter`, data: arg0});
  }

  /**
   * HTTP POST /instancemodele/search
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.searchInstanceModeleFormulaire
   */
  searchInstanceModeleFormulaire(arg0: RechercheInstanceModeleFormulaireDto): RestResponse<PaginationInstanceModeleFormulaireResultDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`instancemodele/search`, data: arg0});
  }

  /**
   * HTTP DELETE /instancemodele/delete/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.supprimerInstanceModeleFormulaire
   */
  supprimerInstanceModeleFormulaire(id: number): RestResponse<number> {
    return this.httpClient.request({method: 'DELETE', url: uriEncoding`instancemodele/delete/${id}`});
  }
}

@Injectable()
export class IModeleFormulaireWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP POST /modeleformulaire/addModele
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.enregistrerModeleFormulaire
   */
  enregistrerModeleFormulaire(arg0: SaveModeleFormulaireDto): RestResponse<number> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`modeleformulaire/addModele`, data: arg0});
  }

  /**
   * HTTP GET /modeleformulaire/{id}/access
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.getAuthorizationAccessEdit
   */
  getAuthorizationAccessEdit(id: number): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`modeleformulaire/${id}/access`});
  }

  /**
   * HTTP GET /modeleformulaire/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.getModeleFormulaire
   */
  getModeleFormulaire(id: number): RestResponse<ModeleFormulaireDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`modeleformulaire/${id}`});
  }

  /**
   * HTTP GET /modeleformulaire/all
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.getModeleFormulaireAll
   */
  getModeleFormulaireAll(): RestResponse<ModeleFormulaireDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`modeleformulaire/all`});
  }

  /**
   * HTTP GET /modeleformulaire/nomdisponible/{nom}/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.nomDisponible
   */
  nomDisponible(nom: string, id: number): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`modeleformulaire/nomdisponible/${nom}/${id}`});
  }

  /**
   * HTTP POST /modeleformulaire/search
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.searchModeleFormulaire
   */
  searchModeleFormulaire(arg0: RechercheModeleDto): RestResponse<ModeleFormulaireDto[]> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`modeleformulaire/search`, data: arg0});
  }

  /**
   * HTTP POST /modeleformulaire/admin/search
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.searchModeleFormulaireAdmin
   */
  searchModeleFormulaireAdmin(arg0: RechercheModeleDto): RestResponse<PaginationModeleResultDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`modeleformulaire/admin/search`, data: arg0});
  }

  /**
   * HTTP DELETE /modeleformulaire/delete/{id}
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.supprimerModeleFormulaire
   */
  supprimerModeleFormulaire(id: number): RestResponse<number> {
    return this.httpClient.request({method: 'DELETE', url: uriEncoding`modeleformulaire/delete/${id}`});
  }

  /**
   * Upload un fichier
   * HTTP POST /modeleformulaire/upload
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IModeleFormulaireWebService.uploadFile
   */
  uploadFile(arg0: any): RestResponse<Response> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`modeleformulaire/upload`, data: arg0});
  }
}

@Injectable()
export class IConfigComplementDossierWebServiceClient {
  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /config/getServeurResultatsApiUri
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IConfigComplementDossierWebService.getServeurResultatsApiUri
   */
  getServeurResultatsApiUri(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`config/getServeurResultatsApiUri`});
  }
}

@Injectable()
export class ITagsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /tags/admin
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.ITagsWebService.isFormulaireDematAdminEnabled
   */
  isFormulaireDematAdminEnabled(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`tags/admin`});
  }

  /**
   * HTTP GET /tags/check
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.ITagsWebService.isFormulaireDematEnabled
   */
  isFormulaireDematEnabled(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`tags/check`});
  }
}

@Injectable()
export class IGedWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /search
   * Response code 204 - *Retourne la liste des fichiers associÃ©s Ã  un tag
   * HTTP GET /ged/search
   * Java method: fr.cerba.digicerba.ged.webservices.IGedWebService.searchFiles
   */
  searchFiles(queryParams?: { tag?: string; }): RestResponse<GedFileDescription[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ged/search`, queryParams: queryParams});
  }
}

@Injectable()
export class IRessourceMultimediaWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /{id}
   * Response code 200 - Ressource multimedia rÃ©cupÃ©rÃ©e avec succÃ¨s
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration du contenu
   * HTTP GET /ressourcemultimedia/{id}
   * Java method: fr.cerba.digicerba.resourcemultimedia.webservices.IRessourceMultimediaWebService.getRessourceMultimedia
   */
  getRessourceMultimedia(id: number): RestResponse<Response> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ressourcemultimedia/${id}`});
  }
}

@Injectable()
export class ICorrespondantWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getAllTags
   */
  getAllTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags/all`});
  }

  /**
   * /
   * Response code 200 - Retourne le dÃ©tail des infos d'un correspondant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/{code}/details
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondantDetails
   */
  getCorrespondantDetails(code: string): RestResponse<CorrespondantDetailsDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}/details`});
  }

  /**
   * /
   * Response code 200 - Retourne la liste des correspondant de l'utilisateur courant avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/all`});
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/tags
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getTags
   */
  getTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags`});
  }
}

@Injectable()
export class INotificationsCommonWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * messages/count
   * HTTP GET /notification/messages/count
   * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.countMessageNotifications
   */
  countMessageNotifications(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/messages/count`});
  }
}

@Injectable()
export class ITechnicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /correspondant/all
   * Response code 200 - Retourne les correspondants actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/correspondants/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/correspondants/all`});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTags
   */
  getTags(queryParams?: { locale?: string; }): RestResponse<TagLightDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/tags/all`, queryParams: queryParams});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs pour une catÃ©gorie
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/tags/byCategorie
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTagsByCategorie
   */
  getTagsByCategorie(queryParams?: { locale?: string; categorie?: string; }): RestResponse<string[]> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`technic/tags/byCategorie`,
      queryParams: queryParams
    });
  }
}

@Injectable()
export class IUserInformationsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /check
   * Response code 200 - Retourne true si le module est accessible
   * Response code 401 - Le module n'est pas accessible
   * HTTP GET /check
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.checkAccess
   */
  checkAccess(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`check`});
  }

  /**
   * /
   * Response code 200 - Retourne les informations de l'utilisateur avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /me
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.me
   */
  me(): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`me`});
  }
}

@Injectable()
export class IServeurResultatsWebServiceClient {

  serveurResultatsApiUri: string[];

  constructor(protected httpClient: HttpClient, protected configComplementDossierWebServiceClient: IConfigComplementDossierWebServiceClient) {
    this.initApi();
  }

  private async initApi() {
    this.serveurResultatsApiUri = await this.configComplementDossierWebServiceClient.getServeurResultatsApiUri().toPromise();
  }

  /**
   * searchDossiersNomPrenomByIds
   * Response code 200 -
   * HTTP POST ${serveur-resultats-api}/dossiers/searchNomPrenomByIds
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.ILaboratoireWebService.findByIdentifiants
   */
  searchDossiersNomPrenomByIds(arg0: string[]): RestResponse<LigneDossierDto[]> {
    return this.httpClient.request({
      method: 'POST',
      url: this.serveurResultatsApiUri[0] + '/dossiers/searchNomPrenomByIds',
      data: arg0
    });
  }
}

export type RestResponse<R> = Observable<R>;

export type EtatEnum = 'EN_COURS' | 'TERMINE' | 'EN_ATTENTE' | 'A_VALIDER';

export type TypeAnomalieEnum = 'ADMINISTRATIFS' | 'RESULTATS' | 'DOCUMENTS';

export type StatutDemandeEnum = 'EN_COURS' | 'TERMINE';

export type UserRole =
  'COMPTE_LIE'
  | 'INVITE'
  | 'ANCIEN_COMPTE'
  | 'ADMINISTRATEUR'
  | 'RESPONSABLE'
  | 'MODULE'
  | 'PROSPECT';

export type RechercheModeleTriEnum = 'TITRE' | 'CATEGORIE';

export type RechercheDossierBloqueTriEnum =
  'DATE_CREATION'
  | 'NUMERO_DE_DOSSIER'
  | 'NOM_PRENOM_PATIENT'
  | 'REF_LABO'
  | 'STATUT';

export type Family = 'INFORMATIONAL' | 'SUCCESSFUL' | 'REDIRECTION' | 'CLIENT_ERROR' | 'SERVER_ERROR' | 'OTHER';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '/formulaire-demat/api/';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/resources/resources.ts